import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';
import { Loader2, Lock } from 'lucide-react';
import { adminLogin } from '../lib/api';

export default function AdminLogin() {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      const r = await adminLogin({ email, password });
      localStorage.setItem('admin_token', r.data.token);
      localStorage.setItem('admin_email', r.data.email);
      localStorage.setItem('admin_role', r.data.role || 'admin');
      localStorage.setItem('admin_name', r.data.name || r.data.email);
      navigate('/ops/dashboard');
    } catch (e) {
      setError('Invalid credentials. Please try again.');
    }
    setLoading(false);
  };

  return (
    <div className="min-h-screen bg-slate-900 flex items-center justify-center px-6" data-testid="admin-login-page">
      <div className="w-full max-w-sm">
        <div className="text-center mb-8">
          <div className="w-12 h-12 bg-slate-800 border border-slate-700 flex items-center justify-center mx-auto mb-4">
            <Lock className="w-5 h-5 text-slate-400" />
          </div>
          <h1 className="text-2xl font-semibold text-white tracking-tight" style={{ fontFamily: "'Playfair Display', serif" }}>
            Admin Console
          </h1>
          <p className="text-sm text-slate-400 mt-1">Buy In Burlington Lead Management</p>
        </div>

        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <Label className="text-sm font-medium text-slate-300 mb-2 block" htmlFor="admin-email">Email</Label>
            <Input
              id="admin-email"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="bg-slate-800 border-slate-700 text-white rounded-sm h-12 focus:border-slate-500"
              placeholder="Email address"
              data-testid="admin-email-input"
            />
          </div>
          <div>
            <Label className="text-sm font-medium text-slate-300 mb-2 block" htmlFor="admin-password">Password</Label>
            <Input
              id="admin-password"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="bg-slate-800 border-slate-700 text-white rounded-sm h-12 focus:border-slate-500"
              placeholder="Enter password"
              data-testid="admin-password-input"
            />
          </div>

          {error && <p className="text-sm text-red-400 text-center" data-testid="admin-login-error">{error}</p>}

          <Button
            type="submit"
            disabled={loading || !email || !password}
            className="w-full bg-white text-slate-900 hover:bg-slate-100 rounded-sm py-3 font-medium h-auto"
            data-testid="admin-login-submit"
          >
            {loading ? <><Loader2 className="w-4 h-4 mr-2 animate-spin" /> Signing in...</> : 'Sign In'}
          </Button>
        </form>
      </div>
    </div>
  );
}
